<template>
  <div class="form-outline">
    <form-legend :field="field" />
    <v-input
      :ref="'table-' + field.cid"
      :rules="field.required ? [() => fieldValue.length > 0 || $t('field.required')] : []"
      :hint="field.field_options.description"
      persistent-hint
      v-bind="darkOrLightMode"
    >
      <div style="width: 100%">
        <v-row v-for="(row, rowIndex) in fieldValue" :key="'row-' + field.label + '-' + rowIndex">
          <v-col v-for="(col, colIndex) in field.field_options.columns" :key="'col-' + field.label + '-' + rowIndex + '-' + colIndex">
            <v-text-field
              v-model="fieldValue[rowIndex][col.label]"
              :label="col.label"
              :rules="getFieldRules({ required: col.requi !== 'no' })"
              :type="col.itype"
              :readonly="readonly"
            />
          </v-col>
          <v-col cols="1" align-self="center">
            <v-btn v-if="!readonly" icon @click="fieldValue.splice(rowIndex, 1)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-btn v-if="!readonly" text @click="addRow" outlined>{{ $t('forms.editors.table.addRow') }}</v-btn>
      </div>
<!--      <template v-slot:message="{ message }">-->
<!--        <legend v-html="message" />-->
<!--      </template>-->
    </v-input>
  </div>
</template>

<script>
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  mixins: [formsMixin],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  data() {
    return {
      fieldValue: this.formModel[this.field.cid] ? this.formModel[this.field.cid] : [],
    };
  },
  methods: {
    addRow() {
      const columns = {};
      this.field.field_options.columns.forEach((col) => {
        columns[col.label] = '';
      });
      this.fieldValue.push(columns);
    },
    formUpdated(value) {
      this.$emit('formUpdated', this.field.cid, value);
    },
  },
  watch: {
    fieldValue(newValue) {
      if (newValue) {
        this.$refs['table-' + this.field.cid].validate();
      }
      this.$emit('formUpdated', this.field.cid, newValue);
    },
    formModel(newValue) {
      const value = newValue[this.field.cid] ? newValue[this.field.cid] : [];
      if (this.fieldValue != value) {
        this.fieldValue = value;
      }
    },
  },
};
</script>
